import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "flex flex-row justify-between" }
const _hoisted_2 = { class: "text-16px font-semibold p-4" }
const _hoisted_3 = {
  key: 0,
  class: "flex flex-col p-4"
}
const _hoisted_4 = { class: "flex flex-row justify-between" }
const _hoisted_5 = { class: "text-16px font-semibold p-4" }
const _hoisted_6 = {
  key: 0,
  class: "flex flex-col p-4"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_skeleton = _resolveComponent("skeleton")!
  const _component_BarCharts = _resolveComponent("BarCharts")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_Card, null, {
      default: _withCtx(() => [
        _createVNode("div", _hoisted_1, [
          _createVNode("div", _hoisted_2, _toDisplayString(_ctx.$t("dexAssessmentDashboard.backlogTicketDexAgenCsL1")), 1)
        ]),
        (_ctx.isLoading)
          ? (_openBlock(), _createBlock("div", _hoisted_3, [
              _createVNode(_component_skeleton, {
                width: "100%",
                height: "15rem"
              })
            ]))
          : (_openBlock(), _createBlock(_component_BarCharts, _mergeProps({ key: 1 }, _ctx.grouppedBarChartL1), null, 16))
      ]),
      _: 1
    }),
    _createVNode(_component_Card, null, {
      default: _withCtx(() => [
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, _toDisplayString(_ctx.$t("dexAssessmentDashboard.backlogTicketDexAgenCsL2")), 1)
        ]),
        (_ctx.isLoading)
          ? (_openBlock(), _createBlock("div", _hoisted_6, [
              _createVNode(_component_skeleton, {
                width: "100%",
                height: "15rem"
              })
            ]))
          : (_openBlock(), _createBlock(_component_BarCharts, _mergeProps({ key: 1 }, _ctx.grouppedBarChartL2), null, 16))
      ]),
      _: 1
    })
  ], 64))
}